/* jscs:disable disallowFunctionDeclarations*/
(function(){
    'use strict';

    angular
      .module('AcaApp')
      .directive('ngHistStatusState', NgHistStatusState);

    function NgHistStatusState(){
        return {
          scope:{
            parent: '=',
            currentPage: '=',
            xmitFilesToState: '=',
            onClickRows: '&',
            editXmitState: '&',
            canEdit: '=',
            goToReview: '&'
          },
          templateUrl: 'app/views/common/directives/historyStatus/historyStatusStateTransmittal.html',
          link: function(scope){
            scope.token = sessionStorage.token;
            scope.propertyName = 'timeoftransmittal';
            scope.onOrderChange = function(propertyName){
              scope.reverse = (scope.propertyName === propertyName) ? !scope.reverse : false;
              scope.propertyName = propertyName;
            };

            scope.clickEditXmitState = function(file){
              scope.editXmitState({message: file});
            };

            scope.displayActionButton = function(file){
              var action;
              if(parseInt(window.sessionStorage.taxYear) >= 2020){
                switch(file.status){
                  case 'Ready':
                    action = 'Resume';
                    break;
                  case 'Cancelled':
                  case 'Complete':
                  case 'Submitted':
                    action = 'Download';
                    break;
                }
              }
              else{
                if(file.state == 'DC')
                  action = 'Download';
              }
              return action;
            };

            scope.hideColumns = parseInt(window.sessionStorage.taxYear) > 2019
          }
       };
    }
  })();